<common-ui-components-page-layout
  [icon]="headerIcon()"
  [showBorder]="false"
  (onBackAction)="handelHeaderAction()"
  [hasBackAction]="false"
>
  <div class="h-100 surface-elevated px-plus d-flex flex-column justify-content-center position-relative">
    @switch (state()) {
      @case (LoginState.PHONENUMBER) {
        <auth-applet-enter-phone-number (okReturned)="prepareStatesForOtp()"></auth-applet-enter-phone-number>
      }
      @case (LoginState.OTP) {
        <common-otp-fill-otp
          [otpLength]="6"
          [phoneNumber]="phoneNumber"
          (okReturned)="otpFilled($event)"
        ></common-otp-fill-otp>
      }
      @case (LoginState.PIN) {
        <common-pin-layout
          [pinConfig]="{
            phoneNumber: phoneNumber,
            type: true,
            isCallTac: isCallTac(),
            resetPinCallbackUrl: resetPinCallbackUrl(),
          }"
          (callbackFunction)="pinCallback($event)"
        ></common-pin-layout>
      }
      @case (LoginState.RULES) {
        <auth-applet-rules></auth-applet-rules>
      }
      @case (LoginState.REPRESENTATIVE) {
        <auth-applet-presentative-code></auth-applet-presentative-code>
      }
    }
  </div>
</common-ui-components-page-layout>
